import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonApiService } from 'src/helper/common-api.service';

@Component({
  selector: 'app-view-youtube',
  templateUrl: './view-youtube.component.html',
  styleUrls: ['./view-youtube.component.css']
})
export class ViewYoutubeComponent implements OnInit {

  youtubeID :any;
  constructor( private commonApiService:CommonApiService,
    private ref : ChangeDetectorRef,
    public sanitizer: DomSanitizer,
    private route : ActivatedRoute,
    private router : Router
    ) { 
      this.route.queryParams.subscribe((t)=>{
        if(t?.id)
        {
          this.youtubeID = t.id
        }else{
          this.router.navigate(["/"])
        }
      });
    }

  ngOnInit(): void {
   
  }

  
  securityByPass(url: any){
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


}
